import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9s3ypu7pv: FaireProductEntity = {
  token: "p_d9s3ypu7pv",
  type: "product",
  name: "Tie Dye Jumpsuit",
  brandToken: "b_2y1von4s08",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5d45af035422eb2a151aeb55a3c029cf8845f1b02c2cdf1ee60203fb2a61043d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/929da08d0b7f9e65522d494e8838be192d07f7ca8a458132c4c01f85674ecd51.jpeg",
    "https://cdn.faire.com/fastly/6a51d30e30e9650be02de1b515f78a4287527b7a1992ca2de89dfe39cd4c7641.jpeg",
    "https://cdn.faire.com/fastly/5fe5157c8df5fc06f985184b8001608f168596442bbf8e739b91c8fb6837d277.jpeg",
    "https://cdn.faire.com/fastly/6c3c7154a47f00b3d090c9e55a84674651ed829bd6bc68542f3588b076f67c62.jpeg",
    "https://cdn.faire.com/fastly/ddc3e3f5ac13afd40f070d8a80c753cea730573a053ecec37232a661cd1e324f.jpeg",
    "https://cdn.faire.com/fastly/43ca8097d50fe0568643f9767c673bea2e5747eaeb8413c3433f91bc42f0df2d.jpeg",
    "https://cdn.faire.com/fastly/4e0738986025d705a443c56784df30829bba0ce0f05e16bdb191c3bb2d719bf8.jpeg",
  ],
  priceDollars: 26.9,
  description:
    "Experience the enchantment of this floaty boho-style wide-leg tie-dye jumpsuit. Embrace cool-wear comfort and mesmerising movement in this one-piece wonder. With its open front and back neckline, adjustable narrow shoulder straps, and functional side seam pockets, this jumpsuit has been designed to make you look and feel fabulously spirit-free whether you dress it up or down.\n\nAccessorise with our tie dye headband to finish the look. And if you love tie dye, don't miss more colour delights in this range!\n\n100% Cotton",
  tags: [],
  msrpDollars: 53.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:25.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
